import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
  className?: string;
}

/** 상태 표시용 배지 (활성/비활성, 연동 상태 등) */
export default function Badge({ tone = 'neutral', children, className = '' }: BadgeProps) {
  const classes = ['badge', `badge--${tone}`, className].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
}
